import { defineStore } from "pinia";

export const useLoadingStore = defineStore("loading", {
  state: () => ({
    activeLoadings: 0, // Yüklenmekte olan işlemleri takip için sayaç
  }),

  actions: {
    startLoading() {
      this.activeLoadings++;
    },
    finishLoading() {
      if (this.activeLoadings > 0) this.activeLoadings--;
    },
  },

  getters: {
    isLoading: (state) => state.activeLoadings > 0,
  },
});
